import React, { useRef } from "react";

const Modal = ({ children, onClose, onClickOutside = false, loading = false }) => {
  const ref = useRef(null);
  const body = document.querySelector("body")
  body.classList.add("overflow-hidden");

  const closeModal = () => {
    onClose();
    body.classList.remove("overflow-hidden");
  };

  const onClickOutsideModal = (e) => {
    if (onClickOutside && e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <div
      className="fixed overflow-auto flex items-center"
      style={{
        backgroundColor: "rgba(0, 0, 0, .4)",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        zIndex: 5000
      }}
      onClick={(e) => onClickOutsideModal(e)}
    >
      <div
        ref={ref}
        className="relative p-8 border-2 border-gray-800 bg-white w-full max-w-md m-auto h-custom"
        style={{
          minWidth: "300px",
          maxWidth: "700px"
        }}
      >
        <div className="text-right">
          <button disabled={loading} onClick={closeModal} className="w-3 cursor-pointer">
            X
          </button>
        </div>

        {children}
      </div>
    </div>
  );
};

export default Modal;
